export default __webpack_public_path__ + "static/media/star-black-18-dp-copy-2.769f9ce3.svg";